export function initStickyStarterNav(){
    const navContainer = document.querySelector('[data-nav-container]');
    const footer = document.querySelector('#footer');
    const pageHeightElement = document.getElementById('main') || document.documentElement;

    if(window.IntersectionObserver){
        initIntersectionObserver(navContainer, footer, pageHeightElement);
    }
    else{
        initScrollListener(navContainer, footer, pageHeightElement);
    }
}

function initIntersectionObserver(navContainer, footer, pageHeightElement){
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    };
      
    const menuObserver = new IntersectionObserver((entries)=>{
        let isVisible = false;
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                isVisible = true;
            }
        });

        toggleStickyStarterNav(isVisible, pageHeightElement);
    
    }, options);

    menuObserver.observe(navContainer);
    menuObserver.observe(footer);
}

function toggleStickyStarterNav(areNavOrFooterVisible, pageHeightElement){
    //hide the button on short pages (e.g. /business-types) because it can be jarring for the button to appear and then immediately disappear 
    //checking here because not only would it be more error prone to hook/unhook listeners on window resize/rotate, but also page height can 
    //change dynamically such as if accordians are opened and closed
    if(pageHeightElement.scrollHeight < 1200 || areNavOrFooterVisible){
        document.body.classList.remove('sticky-starter-nav--active');
    }
    else{
        document.body.classList.add('sticky-starter-nav--active');
    }
}

//based on: https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
//only check vertical position, since we don't have horizontal scrolling and nav and footer should be full width anyway
//checks if any part of the element is visible at all, as compared to the source which checks if every part of the element is visible
function isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();

    //determine if top of element is below bottom of the viewport
    if(bounding.top >= 0){
        return bounding.top < (window.innerHeight || document.documentElement.clientHeight);
    }
    //top of element is offscreen so calculate if element is tall enough so the bottom will appear oncreen
    else{
        return bounding.top + bounding.height > 0;
    }
};

//fallback for browsers that don't support IntersectionObserver (IE and Safari pre 12.2)
function initScrollListener(navContainer, footer, pageHeightElement){
    window.addEventListener('scroll', (e)=>{
        const areNavOrFooterVisible = isInViewport(navContainer) || isInViewport(footer);
        toggleStickyStarterNav(areNavOrFooterVisible, pageHeightElement);
    });
}